import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    remitos: [],

    /* Filtro */
    fechaDesde: moment(new Date()).add(-90, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    transporteId: 0,
    transporte: null,
    transporteNombre: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.remitos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-90, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.transporteId = 0;
        state.transporte = null;
        state.transporteNombre = null;
    },

    'INICIALIZAR_REMITOS' (state) {
        state.remitos = [];
        // state.transporteId = 0;
        // state.transporte = null;
        // state.transporteNombre = null;
    },
    'SET_TRANSPORTE'(state, transporte) {
        state.transporte = transporte;
        state.transporteId = transporte? transporte.id : 0;
        state.transporteNombre = transporte? transporte.nombre.trim() : null;
    },
    'SET_REMITOS' (state, remitos) {
        state.remitos = remitos.map(remito => ({
            remitoId: remito.id,
            presupuestoInternoId: remito.presupuestoInternoId,
            presupuestoNumero: remito.presupuestoNumero,
            presupuestoInterno: [],
            fechaComprobante: remito.fechaComprobante,
            comprobante: remito.comprobante,
            destino: remito.remitoDestino.trim(),
            usuario: remito.usuario.trim(),
            importe: remito.importe,
            importeActualizado: remito.importe,
            rowVersion: remito.rowVersion,
            _rowVariant: '',
            _showDetails: remito.presupuestoInternoId != 0,
            presupuestoInterno: [{
                presupuestoInterno: remito.presupuestoInternoId != 0 ? '(' + remito.presupuestoNumero.toString().trim() + ') ' + remito.presupuestoInterno.trim() : '',
                ordenTrabajo: remito.ordenTrabajoId != 0 ? '(' + remito.ordenTrabajoId.toString().trim() + ') ' + remito.ordenTrabajo.trim() : '',
                subtrabajo: remito.ordenSubtrabajoId != 0 ? '(' + remito.ordenSubtrabajoId.toString().trim() + ') ' + remito.ordenSubtrabajo.trim() : '',
            }]
        }));
    },
    'SET_IMPORTE' (state, params) {
        let remito = state.remitos.find(remito => remito.remitoId == params.remitoId);
        if (remito) {
            remito.importe = params.importe;
            remito.rowVersion = params.rowVersion;
        }
    }
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    inicializar ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_REMITOS');

            if (state.transporteId != 0) {
                let queryString = '?transporteId='+ state.transporteId
                    + '&fechaDesde=2021-04-01'

                apiAxios.get('remitos/actualizar-importes' + queryString)
                    .then(res => {
                        commit('SET_REMITOS', res.data);
                        resolve();
                    })
                    .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
    setTransporte ({ commit }, transporte) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_REMITOS');

            commit('SET_TRANSPORTE', transporte);

            if (transporte) {
                // let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                //     + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                //     + '&sortByDescending='+ state.sortByDescending;

                let queryString = '?transporteId='+ transporte.id
                    + '&fechaDesde=2021-04-01'

                apiAxios.get('remitos/actualizar-importes' + queryString)
                    .then(res => {
                        commit('SET_REMITOS', res.data);
                        resolve();
                    })
                    .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    actualizarImporte( { state, commit }, remitoId) {
        return new Promise((resolve, reject) => {
            let remito = state.remitos.find(remito => remito.remitoId == remitoId);
            
            if (remito) {
                let remitoImporte = {
                    remitoId: remitoId,
                    importe: remito.importeActualizado,
                    rowVersion: remito.rowVersion
                }

                apiAxios.post(`remitos/${remitoId}/importe`, remitoImporte)
                    .then(res => {
                        let params = {
                            remitoId: res.data.id,
                            importe: remito.importeActualizado,
                            rowVersion: res.data.rowVersion
                        }

                        commit('SET_IMPORTE', params);

                        resolve();
                    })
                    .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(new Error('Se produjo un error al recuperar la información del remito'));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}